export const AUTHORIZATIONS_QS = { ERROR: 'autherr' };
